import { useQuery } from '@tanstack/react-query';
import { endpoints } from 'api/endpoints';
import { useRef } from 'react';
import { useAppStore } from 'stores/appStore';

export const useNameSuggestions = () => {
  const selectedCategory = useAppStore((state) => state.selectedCategory);

  const previousResults = useRef<string[]>([]);

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ['name-suggestions', selectedCategory],
    queryFn: () => endpoints.suggestSiteNames({ category: selectedCategory, previousResults: previousResults.current }),
    select: (response) => {
      previousResults.current = response.suggestions ?? [];
      return response.suggestions;
    },
  });

  return { suggestions: data, isLoading: isLoading || isFetching, refetch };
};
